import React, { useState } from 'react';
import { StepProps, Specialty, SPECIALTY_COLORS } from '../../types';
import { motion } from 'framer-motion';
import { Droplets, Heart, FlaskConical, Stethoscope, ArrowRight } from 'lucide-react';
export function GroupSetup({
  state,
  updateState,
  nextStep
}: StepProps) {
  const [groupName, setGroupName] = useState(state.groupName);
  const roles: {
    id: Specialty;
    icon: React.ElementType;
    label: string;
  }[] = [{
    id: 'Nephrologist',
    icon: Droplets,
    label: 'Nephrologist'
  }, {
    id: 'Cardiologist',
    icon: Heart,
    label: 'Cardiologist'
  }, {
    id: 'Endocrinologist',
    icon: FlaskConical,
    label: 'Endocrinologist'
  }, {
    id: 'PCP',
    icon: Stethoscope,
    label: 'PCP'
  }];
  const handleSelect = (id: Specialty) => {
    updateState({
      selectedSpecialty: id
    });
  };
  const handleContinue = () => {
    updateState({
      groupName
    });
    nextStep();
  };
  const isReady = state.selectedSpecialty && groupName.trim().length > 0;
  return <div className="flex-grow flex flex-col justify-center items-center px-6 py-12 min-h-screen pt-20" data-id="element-451">
      <div className="max-w-4xl w-full mx-auto" data-id="element-452">
        <div className="text-center mb-12" data-id="element-453">
          <span className="text-brand font-semibold tracking-wider uppercase text-sm mb-2 block" data-id="element-454">
            Group Setup
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-dark" data-id="element-455">
            Select Your Group's Specialty
          </h2>
          <p className="text-gray-500 mt-4 text-lg" data-id="element-456">
            Choose the specialty your table has been assigned and give your
            group a name.
          </p>
        </div>

        <div className="bg-white rounded-3xl p-8 border border-gray-200 shadow-sm mb-10" data-id="element-457">
          <div className="mb-8" data-id="element-458">
            <label htmlFor="groupName" className="block text-sm font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-459">
              Group Name
            </label>
            <input type="text" id="groupName" value={groupName} onChange={e => setGroupName(e.target.value)} placeholder="e.g. Table 1, The Kidney Crew" className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-brand focus:ring-0 text-lg transition-colors outline-none" data-id="element-460" />
          </div>

          <div data-id="element-461">
            <label className="block text-sm font-bold text-gray-700 uppercase tracking-wider mb-4" data-id="element-462">
              Assigned Specialty
            </label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-463">
              {roles.map(role => {
              const Icon = role.icon;
              const isSelected = state.selectedSpecialty === role.id;
              return <motion.button key={role.id} whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} onClick={() => handleSelect(role.id)} className={`
                      relative p-4 rounded-xl border-2 text-left flex items-center transition-all duration-200
                      ${isSelected ? 'bg-gray-50' : 'border-gray-200 hover:border-gray-300'}
                    `} style={{
                borderColor: isSelected ? SPECIALTY_COLORS[role.id] : undefined
              }} data-id="element-464">
                    <div className="p-3 rounded-full mr-4" style={{
                  backgroundColor: `${SPECIALTY_COLORS[role.id]}15`,
                  color: SPECIALTY_COLORS[role.id]
                }} data-id="element-465">
                      <Icon size={24} data-id="element-466" />
                    </div>
                    <span className="text-lg font-bold text-dark" data-id="element-467">
                      {role.label}
                    </span>
                  </motion.button>;
            })}
            </div>
          </div>
        </div>

        <div className="flex justify-center h-16" data-id="element-468">
          {isReady && <motion.button initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} onClick={handleContinue} className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-dark rounded-full hover:bg-black transition-colors shadow-lg" data-id="element-469">
              Start Your Deep Dive
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-470" />
            </motion.button>}
        </div>
      </div>
    </div>;
}